module.exports = __webpack_public_path__ + "f93c5914defc43af730d924132e8a152.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-98.cur
// module id = 488
// module chunks = 0